import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import { referralAPI } from '../../services/api';

const AddClientModal = ({ isOpen, onClose }) => {
  const [coachCode, setCoachCode] = useState('');
  const [copied, setCopied] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isOpen) {
      fetchReferralCode();
    }
  }, [isOpen]);

  const fetchReferralCode = async () => {
    try {
      setLoading(true);
      const res = await referralAPI.getMyReferrals();
      setCoachCode(res.data.coachCode);
    } catch (err) {
      console.error('Failed to load referral info', err);
    } finally {
      setLoading(false);
    }
  };

  const inviteUrl = `${window.location.origin}/register?ref=${coachCode}`;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(inviteUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Invite New Client">
      {loading ? (
        <div className="flex justify-center p-8">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[var(--tangerine)]"></div>
        </div>
      ) : (
        <div className="space-y-6">
          <p className="text-sm text-gray-600">
            Share this personalized link with your clients. When they sign up using this link, they will automatically be added to your client list.
          </p>
          
          <div>
            <label className="block text-xs font-bold text-gray-700 uppercase tracking-wide mb-2">Your Invite Link</label>
            <div className="flex gap-2">
              <input 
                type="text" 
                readOnly 
                value={inviteUrl} 
                className="flex-1 bg-gray-50 border border-gray-200 text-gray-800 text-sm rounded-xl focus:ring-[var(--tangerine)] focus:border-[var(--tangerine)] block w-full p-3 shadow-inner"
              />
              <button 
                onClick={copyToClipboard}
                className="bg-gray-100 hover:bg-gray-200 border border-gray-200 text-gray-700 font-bold py-2 px-4 rounded-xl transition-colors shrink-0 flex items-center justify-center gap-2"
              >
                <span className="material-symbols-outlined text-[18px]">
                  {copied ? 'check' : 'content_copy'}
                </span>
                {copied ? 'Copied!' : 'Copy'}
              </button>
            </div>
          </div>
          
          <div className="bg-orange-50 border border-orange-100 rounded-2xl p-4 flex gap-3 text-orange-800">
            <span className="material-symbols-outlined shrink-0 text-xl text-[var(--tangerine)]">info</span>
            <div className="text-sm leading-relaxed">
              <span className="font-bold">Manual Registration:</span> If your client registers independently, they can manually enter your Coach Code: <strong className="font-mono bg-white px-2 py-0.5 rounded border border-orange-200 ml-1">{coachCode}</strong>
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default AddClientModal;
